module.exports = __webpack_public_path__ + "img/step1-text.9b0e4acd.png";